import React from "react";
import Head from "next/head";

import PropertyDocuments from "components/PropertyDocuments";

import { useFormattedMessage } from "hooks";
import { neucollect01 } from "i18n/messages/meta";
import { getDocumentsHost } from "common/helper";

const DOCUMENT_HOST = getDocumentsHost();

const DERC01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DRC DE-RC-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-RC-01/neucollect-01_DE-RC-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 03/2021 - PDF - 258 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DRC DE-RC-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-RC-01/neucollect-01_DE-RC-01_Basisinformationsblatt.pdf`,
        description: "Stand 03/2021 - PDF - 211 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DRC DE-RC-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-RC-01/neucollect-01_DE-RC-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 211 KB",
    },
];

const DECL01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CLR DE-CL-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CL-01/neucollect-01_DE-CL-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 03/2021 - PDF - 252 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CLR DE-CL-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CL-01/neucollect-01_DE-CL-01_Basisinformationsblatt.pdf`,
        description: "Stand 03/2021 - PDF - 212 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CLR DE-CL-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CL-01/neucollect-01_DE-CL-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 212 KB",
    },
];

const DELP01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CPV DE-LP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-LP-01/neucollect-01_DE-LP-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 03/2021 - PDF - 252 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CPV DE-LP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-LP-01/neucollect-01_DE-LP-01_Basisinformationsblatt.pdf`,
        description: "Stand 03/2021 - PDF - 211 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CPV DE-LP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-LP-01/neucollect-01_DE-LP-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 211 KB",
    },
];

const DEOO01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen RMO DE-OO-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-OO-01/neucollect-01_DE-OO-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 05/2021 - PDF - 252 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* RMO DE-OO-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-OO-01/neucollect-01_DE-OO-01_Basisinformationsblatt.pdf`,
        description: "Stand 05/2021 - PDF - 213 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* RMO DE-OO-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-OO-01/neucollect-01_DE-OO-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 213 KB",
    },
];

const DESM01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen SM DE-SM-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-SM-01/neucollect-01_DE-SM-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 06/2021 - PDF - 252 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* SM DE-SM-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-SM-01/neucollect-01_DE-SM-01_Basisinformationsblatt.pdf`,
        description: "Stand 06/2021 - PDF - 213 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* SM DE-SM-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-SM-01/neucollect-01_DE-SM-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 213 KB",
    },
];

const DECF01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CFS DE-CF-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CF-01/neucollect-01_DE-CF-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2021 - PDF - 253 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CFS DE-CF-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CF-01/neucollect-01_DE-CF-01_Basisinformationsblatt.pdf`,
        description: "Stand 07/2021 - PDF - 213 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CFS DE-CF-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CF-01/neucollect-01_DE-CF-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 213 KB",
    },
];

const DEPG01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen PGV DE-PG-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-PG-01/neucollect-01_DE-PG-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2021 - PDF - 256 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* PGV DE-PG-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-PG-01/neucollect-01_DE-PG-01_Basisinformationsblatt.pdf`,
        description: "Stand 07/2021 - PDF - 215 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* PGV DE-PG-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-PG-01/neucollect-01_DE-PG-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 215 KB",
    },
];

const DEPH01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-PH-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-PH-01/neucollect-01_DE-PH-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2021 - PDF - 261 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-PH-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-PH-01/neucollect-01_DE-PH-01_Basisinformationsblatt.pdf`,
        description: "Stand 08/2021 - PDF - 218 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-PH-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-PH-01/neucollect-01_DE-PH-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 218 KB",
    },
];

const DEBG01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-BG-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-BG-01/neucollect-01_DE-BG-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 09/2021 - PDF - 261 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-BG-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-BG-01/neucollect-01_DE-BG-01_Basisinformationsblatt.pdf`,
        description: "Stand 09/2021 - PDF - 218 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-BG-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-BG-01/neucollect-01_DE-BG-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 218 KB",
    },
];

const DELR01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-LR-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-LR-01/neucollect-01_DE-LR-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 09/2021 - PDF - 259 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-LR-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-LR-01/neucollect-01_DE-LR-01_Basisinformationsblatt.pdf`,
        description: "Stand 09/2021 - PDF - 220 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-LR-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-LR-01/neucollect-01_DE-LR-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 220 KB",
    },
];

const DEGC01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-GC-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-GC-01/neucollect-01_DE-GC-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 10/2021 - PDF - 258 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-GC-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-GC-01/neucollect-01_DE-GC-01_Basisinformationsblatt.pdf`,
        description: "Stand 10/2021 - PDF - 219 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-GC-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-GC-01/neucollect-01_DE-GC-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 219 KB",
    },
];

const DECM01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-CM-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CM-01/neucollect-01_DE-CM-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 01/2022 - PDF - 422 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CM-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CM-01/neucollect-01_DE-CM-01_Basisinformationsblatt.pdf`,
        description: "Stand 01/2022 - PDF - 224 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CM-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CM-01/neucollect-01_DE-CM-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 224 KB",
    },
];

const DEPP01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-PP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-PP-01/neucollect-01_DE-PP-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 01/2022 - PDF - 255 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-PP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-PP-01/neucollect-01_DE-PP-01_Basisinformationsblatt.pdf`,
        description: "Stand 01/2022 - PDF - 201 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-PP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-PP-01/neucollect-01_DE-PP-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 201 KB",
    },
];

const DEPR01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-PR-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-PR-01/neucollect-01_DE-PR-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 03/2022 - PDF - 254 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-PR-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-PR-01/neucollect-01_DE-PR-01_Basisinformationsblatt.pdf`,
        description: "Stand 03/2022 - PDF - 199 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-PR-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-PR-01/neucollect-01_DE-PR-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 199 KB",
    },
];

const DERC02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-RC-02",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-RC-02/neucollect-01_DE-RC-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 04/2022 - PDF - 253 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-RC-02",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-RC-02/neucollect-01_DE-RC-02_Basisinformationsblatt.pdf`,
        description: "Stand 04/2022 - PDF - 201 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-RC-02",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-RC-02/neucollect-01_DE-RC-02_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 201 KB",
    },
];

const DEBK01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-BK-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-BK-01/neucollect-01_DE-BK-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 04/2022 - PDF - 254 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-BK-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-BK-01/neucollect-01_DE-BK-01_Basisinformationsblatt.pdf`,
        description: "Stand 04/2022 - PDF - 201 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-BK-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-BK-01/neucollect-01_DE-BK-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 201 KB",
    },
];

const DEST01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-ST-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-ST-01/neucollect-01_DE-ST-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 05/2022 - PDF - 252 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-ST-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-ST-01/neucollect-01_DE-ST-01_Basisinformationsblatt.pdf`,
        description: "Stand 05/2022 - PDF - 202 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-ST-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-ST-01/neucollect-01_DE-ST-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 202 KB",
    },
];

const DEAE01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-AE-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-AE-01/neucollect-01_DE-AE-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 06/2022 - PDF - 255 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-AE-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-AE-01/neucollect-01_DE-AE-01_Basisinformationsblatt.pdf`,
        description: "Stand 06/2022 - PDF - 201 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-AE-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-AE-01/neucollect-01_DE-AE-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 201 KB",
    },
];

const DECL02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-CL-02",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CL-02/neucollect-01_DE-CL-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2022 - PDF - 254 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CL-02",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CL-02/neucollect-01_DE-CL-02_Basisinformationsblatt.pdf`,
        description: "Stand 07/2022 - PDF - 200 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CL-02",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CL-02/neucollect-01_DE-CL-02_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 200 KB",
    },
];

const DEDP01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-DP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-DP-01/neucollect-01_DE-DP-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2022 - PDF - 250 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-DP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-DP-01/neucollect-01_DE-DP-01_Basisinformationsblatt.pdf`,
        description: "Stand 07/2022 - PDF - 199 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-DP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-DP-01/neucollect-01_DE-DP-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 199 KB",
    },
];

const DESE01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-SE-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-SE-01/neucollect-01_DE-SE-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2022 - PDF - 253 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-SE-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-SE-01/neucollect-01_DE-SE-01_Basisinformationsblatt.pdf`,
        description: "Stand 07/2022 - PDF - 216 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-SE-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-SE-01/neucollect-01_DE-SE-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 216 KB",
    },
];

const FWBS01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen FW-BS-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/FW-BS-01/neucollect-01_FW-BS-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 10/2022 - PDF - 256 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* FW-BS-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/FW-BS-01/neucollect-01_FW-BS-01_Basisinformationsblatt.pdf`,
        description: "Stand 10/2022 - PDF - 200 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* FW-BS-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/FW-BS-01/neucollect-01_FW-BS-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 200 KB",
    },
];

const FWBP01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen FW-BP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/FW-BP-01/neucollect-01_FW-BP-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 01/2023 - PDF - 232 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* FW-BP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/FW-BP-01/neucollect-01_FW-BP-01_Basisinformationsblatt.pdf`,
        description: "Stand 01/2023 - PDF - 126 KB",
    },
];

const FWTR01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen FW-TR-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/FW-TR-01/neucollect-01_FW-TR-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 03/2023 - PDF - 254 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* FW-TR-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/FW-TR-01/neucollect-01_FW-TR-01_Basisinformationsblatt.pdf`,
        description: "Stand 03/2023 - PDF - 197 KB",
    },
];

const FWJP01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen FW-JP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/FW-JP-01/neucollect-01_FW-JP-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2023 - PDF - 324 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* FW-JP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/FW-JP-01/neucollect-01_FW-JP-01_Basisinformationsblatt.pdf`,
        description: "Stand 07/2023 - PDF - 127 KB",
    },
];

const CDPPFWJP01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-FW-JP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/CD-PP-FW-JP-01/neucollect-01_CD-PP-FW-JP-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2023 - PDF - 326 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-FW-JP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/CD-PP-FW-JP-01/neucollect-01_CD-PP-FW-JP-01_Basisinformationsblatt.pdf`,
        description: "Stand 07/2023 - PDF - 126 KB",
    },
];

const FWUS01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen FW-US-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/FW-US-01/neucollect-01_FW-US-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 09/2023 - PDF - 305 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* FW-US-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/FW-US-01/neucollect-01_FW-US-01_Basisinformationsblatt.pdf`,
        description: "Stand 09/2023 - PDF - 130 KB",
    },
];

const Neucollect01 = () => {
    const { formatMessage } = useFormattedMessage();

    return (
        <>
            <Head>
                <title>{formatMessage(neucollect01.title)}</title>

                <meta name="description" content="neucollect - 01 GmbH & Co. KG" />
            </Head>
            <div className="broad-container issuer-public-page neucollect">
                <section className="banner-section" style={{ backgroundImage: "url(/images/neucollect01.jpg)" }} />
                <section className="content-section small-container">
                    <div className="header-part">
                        <div className="logo-container shadow border-radius">
                            <img src={"/images/logo-neucollect-01.png"} alt="" />
                        </div>
                        <p className="">
                            Der Unternehmensgegenstand der Gesellschaft besteht in dem Erwerb, dem Halten und Verwalten von
                            Sachwerten (die „Sachwerte“), insbesondere Oldtimern und Weinen und anderen Gegenständen, die als
                            Sammlerstücke gelten.
                        </p>
                    </div>
                    <div className="border-x" />
                    <div className="content-part">
                        <h2>neucollect - 01 GmbH & Co. KG</h2>
                        <p>
                            Bei der Finanzierung verfolgt die neucollect - 01 GmbH & Co. KG eine langfristig ausgerichtete
                            Strategie.
                        </p>
                    </div>
                    <div className="two-parts">
                        <div className="first-part">
                            <div className="pdf-part">
                                <h3>Kapitalmarktdokumentation</h3>
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DERC01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DECL01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DELP01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEOO01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DESM01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DECF01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEPG01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEPH01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEBG01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DELR01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEGC01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DECM01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEPP01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEPR01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DERC02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEBK01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEST01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEAE01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DECL02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEDP01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DESE01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={FWBS01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={FWBP01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={FWTR01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={FWJP01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={CDPPFWJP01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={FWUS01DocumentsData} />
                                <span className="bottom-line text-14 d-block">
                                    *Basisinformationsblatt gemäß EU-Verordnung 1286/2014
                                </span>
                            </div>
                        </div>
                        <div className="second-part">
                            <h3>Kontakt</h3>
                            <p>
                                Bei Fragen zu den tokenisierten Schuldverschreibungen sind wir persönlich erreichbar über die
                                E-Mail-Adresse:
                                <br />
                                <a href="mailto:neucollect-01@finexity.com">neucollect-01@finexity.com</a>
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Neucollect01;
